import Widget, { registerModuleClass } from '@sparta.global.utilities/sparta-widget-utility/dist/es6.js';
import { $GTUnAuthNavStore } from '@sparta.global-tenants.stores/gt-unauth-nav-store/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import { compare } from '@sparta.global.helpers/comparisons-helper/dist/es6.js';
import { startsWith } from '@sparta.global.helpers/strings-helper/dist/es6.js';

const Template$1 = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,"head-row","==",(depth0 != null ? lookupProperty(depth0,"position") : depth0),{"name":"compare","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":4},"end":{"line":14,"column":16}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,"head-sub-row","==",(depth0 != null ? lookupProperty(depth0,"position") : depth0),{"name":"compare","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":15,"column":4},"end":{"line":26,"column":16}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"startsWith")||(depth0 && lookupProperty(depth0,"startsWith"))||alias2).call(alias1,"dynamic-row",(depth0 != null ? lookupProperty(depth0,"position") : depth0),{"name":"startsWith","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":27,"column":4},"end":{"line":38,"column":19}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,"foot-row","==",(depth0 != null ? lookupProperty(depth0,"position") : depth0),{"name":"compare","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":39,"column":4},"end":{"line":50,"column":16}}})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <section id=\"head-row\" class=\"small-centered head-row\""
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(alias1,((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"page") : depth0)) != null ? lookupProperty(stack1,"layout") : stack1)) != null ? lookupProperty(stack1,"data-magellan-fixed") : stack1),"==","true",{"name":"compare","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":60},"end":{"line":4,"column":161}}})) != null ? stack1 : "")
    + ">\n        <div class=\"row spa-collapse-small spa-uncollapse-large\">\n          <div class=\"large-12 columns\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(alias1,(depth0 != null ? lookupProperty(depth0,"module") : depth0),{"name":"each","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":14},"end":{"line":10,"column":23}}})) != null ? stack1 : "")
    + "          </div>\n        </div>\n      </section>\n";
},"3":function(container,depth0,helpers,partials,data) {
    return " data-magellan-expedition=\"fixed\"";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                "
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"renderedHTML") : depth0), depth0)) != null ? stack1 : "")
    + "\n";
},"7":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <section class=\"small-centered "
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"sectionClass") : depth0), depth0))
    + " "
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"options") : depth0)) != null ? lookupProperty(stack1,"sectionClass") : stack1), depth0))
    + "\""
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(alias3,((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"page") : depth0)) != null ? lookupProperty(stack1,"layout") : stack1)) != null ? lookupProperty(stack1,"data-magellan-fixed") : stack1),"==","true",{"name":"compare","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":28,"column":89},"end":{"line":28,"column":209}}})) != null ? stack1 : "")
    + ">\n        <div class=\"row spa-collapse-small spa-uncollapse-large\">\n          <div class=\"large-12 small-12 columns\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(alias3,(depth0 != null ? lookupProperty(depth0,"module") : depth0),{"name":"each","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":32,"column":14},"end":{"line":34,"column":23}}})) != null ? stack1 : "")
    + "          </div>\n        </div>\n      </section>\n";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " data-magellan-destination=\""
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"sectionClass") : depth0), depth0)) != null ? stack1 : "")
    + "\"";
},"10":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <section class=\"small-centered foot-row\">\n        <div class=\"row spa-collapse-small spa-uncollapse-large\">\n          <div class=\"large-12 columns\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"module") : depth0),{"name":"each","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":44,"column":14},"end":{"line":46,"column":23}}})) != null ? stack1 : "")
    + "          </div>\n        </div>\n      </section>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div data-component=\"layout\" data-layout=\""
    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"page") : depth0)) != null ? lookupProperty(stack1,"layout") : stack1)) != null ? lookupProperty(stack1,"name") : stack1), depth0))
    + "\" data-version=\""
    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"page") : depth0)) != null ? lookupProperty(stack1,"layout") : stack1)) != null ? lookupProperty(stack1,"layoutVersion") : stack1), depth0))
    + "\" class=\"sparta-layout layout-1col-multi-row\" id=\"top\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"page") : depth0)) != null ? lookupProperty(stack1,"layout") : stack1)) != null ? lookupProperty(stack1,"sections") : stack1),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":2},"end":{"line":51,"column":11}}})) != null ? stack1 : "")
    + "</div>";
},"useData":true});
const renderTemplate$1 = function (data, options) {
  return Template$1(data, options);
};

const Template = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.global-tenants.widgets/gt-nav-unauth-secure-bofa-widget",
  "version": "1.0.0",
  "id": "globalTenantsGtNavUnauthSecureBofaWidget",
  "containerID": "globalTenantsGtNavUnauthSecureBofaWidget",
  "moduleName": "gt-nav-unauth-secure-bofa-widget",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "gt-nav-unauth-secure-bofa-widget",
  "data": {
    "init": "GtNavUnauthSecureBofaWidget"
  },
  "moduleParams": [],
  "layout": renderTemplate$1,
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        compare,
        startsWith
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    compare,
    startsWith
  },
  "dependencies": {
    "@sparta.global.helpers/comparisons-helper": "^1.0.0",
    "@sparta.global.helpers/strings-helper": "^1.0.0",
    "@sparta.global.templates/footnote-suplink": "^1.0.0",
    "@sparta.global.templates/glossary-link": "^1.0.0",
    "@sparta.global.templates/glossary-terms": "^1.0.0",
    "@sparta.global.templates/render-module-template": "^1.0.0",
    "@sparta.global.templates/widget-layout-support-footer": "^1.0.0",
    "@sparta.global.templates/widget-layout-support-header": "^1.0.0",
    "@sparta.global.utilities/sparta-bootstrap-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-widget-utility": "^1.0.0",
    "@sparta.global-tenants.modules/gt-nav-unauth-secure-bofa-module": "^1.0.0",
    "@sparta.global-vtim.utilities/sync-alloy-utility": "^1.0.6",
    "@sparta.global.templates/layout-support-header": "^1.0.0",
    "@sparta.global.templates/link-template": "^1.0.0",
    "@sparta.global-tenants.stores/gt-unauth-nav-store": "^1.0.0",
    "@sparta.global.modules/get-app-modal-module": "^1.0.0"
  }
};

/** Extract Actions */
const actions = {
  ...$GTUnAuthNavStore.actions,
  ...$GTUnAuthBootstrapStore.actions
};

/** Extract Getters */
({
  ...$GTUnAuthNavStore.getters,
  ...$GTUnAuthBootstrapStore.getters
});
({
  ...$GTUnAuthNavStore.mutations
});

/** Store */
const {
  store
} = $GTUnAuthNavStore;

/** Bootstrap Store */
const bootstrapStore = $GTUnAuthBootstrapStore.store;

/** Extract Actions */
const {
  readSpartaJCRs,
  readSpartaSpaParams,
  readGTBrowserViewport,
  readGTBrowserInfo,
  mergeBootstrapStorePage,
  mergeBootstrapStoreRequests,
  watchNavigationViewportChange
} = actions;

/**
 * Widget gt-nav-unauth-secure-bofa-widget
 * @description GT Nav Unauth Secure Bofa Widget
 * @copyright 2025-1-17
 * @file
 */

/**
 * Widget GtNavUnauthSecureBofaWidget
 * @class
 */
class GtNavUnauthSecureBofaWidget extends Widget {
  /**
   * Creates an instance of GtNavUnauthSecureBofaWidget
   * @memberof GtNavUnauthSecureBofaWidget
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });

    /** Transport spaParams to Navigation Store */
    readSpartaSpaParams({
      spaParams: bootstrapStore.state.sparta.spaParams
    });

    /** Transport page to Navigation Store */
    mergeBootstrapStorePage({
      page: bootstrapStore.state.page
    });

    /** Transport JCRs to Navigation Store */
    readSpartaJCRs({
      jcrs: bootstrapStore.state.sparta.jcrs
    });

    /** Bootstrap Store Subscriptions */
    bootstrapStore.subscribe(this.bootstrapStoreSubscriptions.bind(this));

    /** Subscribe to Navigation Store Mutations */
    store.subscribe(this.storeSubscriptions.bind(this));

    /** Read Viewports */
    readGTBrowserViewport();

    /** Read Browser Info */
    readGTBrowserInfo();

    /** Watch Navigation Viewport Change */
    watchNavigationViewportChange();

    /** Transport Requests to Navigation Store */
    mergeBootstrapStoreRequests({
      requests: bootstrapStore.state.requests
    });
  }

  /**
  * Navigation Store Subscriptions
  *
  *
  * @param {Vuex.Mutation} mutation
  * @returns {void}
  */
  storeSubscriptions(mutation) {}

  /**
   * Bootstrap Store Subscriptions
   *
   *
   * @param {Vuex.Mutation} mutation
   * @param {Vuex.State} state
   * @returns {void}
   */
  bootstrapStoreSubscriptions(mutation, state) {}
}

// Export a singleton instance of the widget.

registerModuleClass({
  moduleClass: GtNavUnauthSecureBofaWidget,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { GtNavUnauthSecureBofaWidget as default, moduleConfig };
